import { InjectionToken } from '@angular/core';
import { LvisionBetBoosterApiKeys } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LVISION_BET_BOOSTER_API_KEYS: InjectionToken<LvisionBetBoosterApiKeys> =
  new InjectionToken<LvisionBetBoosterApiKeys>('lvisionBetBoosterApiKeys');
